import Axios from '../../../networking/interceptor';
import { driver_digital_id_card, driver_digital_id_card_save_photo } from '../../../networking/urlEndPoints';

/**
 * GET driver digital ID card. Pass pharmacy_id as query param.
 * @param {number|string} pharmacyId
 * @returns {Promise<{ success: boolean, data: object, message: string }>}
 */
export const fetchDigitalIdCard = async (pharmacyId) => {
	const response = await Axios.get(driver_digital_id_card, {
		params: { pharmacy_id: pharmacyId },
	});
	return response.data;
};

/**
 * POST driver digital ID card profile photo. Sends form-data with key "photo" (file).
 * @param {File|Blob} photoFile - Image file (e.g. from crop)
 * @param {string} [fileName='photo.jpg'] - Filename for the upload
 * @returns {Promise<{ success: boolean, data: { photo_url: string }, message: string }>}
 */
export const saveDigitalIdCardPhoto = async (photoFile, fileName = 'photo.jpg') => {
	const formData = new FormData();
	formData.append('photo', photoFile, fileName);
	const response = await Axios.post(driver_digital_id_card_save_photo, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
	return response.data;
};
